import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { BulkActionType } from 'donor-elf-web/models/bulk-action';
import type { AskFilteredOrSelectedAnswer } from './ask-filtered-or-selected-contacts';

export interface BulkActionsContactsChangedArgs {
  contactIds: string[];
  contactIdsDeleted?: string[];
  bulkActionType: BulkActionType;
  newPropertyAdded?: true;
}

interface ComponentArgs {
  bulkActionType: BulkActionType;
  filteredContactIds: string[];
  selectedContactIds: string[];
  onAddTask: (contactIds: string[]) => void; // fired when bulkActionType is 'add_task' and after the user chooses to add the task for the selected contacts or all the contacts
  onContactsChanged: (args: BulkActionsContactsChangedArgs) => void;
  onClose: () => void;
}

export default class ContactBulkActionsIndexComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    if (
      args.selectedContactIds.length > 0 &&
      args.selectedContactIds.sort().join(',') !==
        args.filteredContactIds.sort().join(',')
    ) {
      this.askFilteredOrSelectedContacts = true;
    } else {
      this.askFilteredOrSelectedContacts = false;
      this.contactIds = args.filteredContactIds;
      if (args.bulkActionType === 'add_task' && !this.noContacts) {
        args.onAddTask(this.contactIds);
        args.onClose();
      }
    }
  }

  @tracked askFilteredOrSelectedContacts = false;
  contactIds?: string[];

  get noContacts() {
    return (
      this.args.selectedContactIds.length === 0 &&
      this.args.filteredContactIds.length === 0
    );
  }

  @action
  handleAnsweredFilteredOrSelectedContacts(
    answer: AskFilteredOrSelectedAnswer,
  ) {
    if (answer === 'filtered') {
      this.contactIds = this.args.filteredContactIds;
    } else {
      this.contactIds = this.args.selectedContactIds;
    }
    this.askFilteredOrSelectedContacts = false;
    if (this.args.bulkActionType === 'add_task') {
      this.args.onAddTask(this.contactIds);
      this.args.onClose();
    }
  }
}
